<template>
  <div class="sino-personal">
    <div v-if="noData =='false'">
      <!-- 头部开始 -->
      <topPart></topPart>
      <!-- 头部结束 -->
      <div class="sino-panel my-content">
        <div class="sino-content">
          <div class="content-card">
            <div class="card-item">
              <div class="item item-label">真实姓名</div>
              <div class="item item-value">{{userInfo.name}}</div>
            </div>
            <div class="card-item">
              <div class="item item-label">性别</div>
              <div class="item item-value">{{userInfo.sex == 1?'男':'女'}}</div>
            </div>
            <div class="card-item">
              <div class="item item-label">所在工会</div>
              <div class="item item-value">{{userInfo.unionName}}</div>
            </div>
            <div class="card-item">
              <div class="item item-label">所在科室</div>
              <div class="item item-value">{{userInfo.deptName}}</div>
            </div>
            <div class="card-item">
              <div class="item item-label">身份证号</div>
              <div class="item item-value">{{userInfo.idCard}}</div>
            </div>
            <div class="card-item">
              <div class="item item-label">年龄</div>
              <div class="item item-value">{{userInfo.age}}</div>
            </div>
            <div class="card-item">
              <div class="item item-label">生日</div>
              <div class="item item-value">{{userInfo.birthday}}</div>
            </div>
            <div class="card-item" v-if="userInfo.phone">
              <div class="item item-label">手机号</div>
              <div class="item item-value" @click="callTel(userInfo.phone)">
                <span>{{userInfo.phone}}</span>
              </div>
            </div>
            <div class="card-item">
              <div class="item item-label">职工代表</div>
              <div class="item item-value">{{userInfo.representative == '1'?'是':'否'}}</div>
            </div>

            <div class="card-item">
              <div class="item item-label">会员代表</div>
              <div class="item item-value">{{userInfo.memberRepre == '1'?'是':'否'}}</div>
            </div>
            <div class="card-item">
              <div class="item item-label">会员状态</div>
              <div class="item item-value">{{userInfo.status}}</div>
            </div>
            <div class="card-item">
              <div class="item item-label">会员身份</div>
              <div class="item item-value">{{userInfo.identity}}</div>
            </div>
            <div class="card-item">
              <div class="item item-label">会员编制</div>
              <div class="item item-value">{{userInfo.authorizedStrength == 0?'正式职工':'派遣职工'}}</div>
            </div>
            <div class="card-item">
              <div class="item item-label">劳动模范</div>
              <div class="item item-value">{{userInfo.modelWorker == '1'?'是':'否'}}</div>
            </div>
            <div class="card-item" v-if="userInfo.post">
              <div class="item item-label">岗位</div>
              <div class="item item-value">{{userInfo.post}}</div>
            </div>
            <div class="card-item" v-if="userInfo.jobTitle">
              <div class="item item-label">职称</div>
              <div class="item item-value">{{userInfo.jobTitle}}</div>
            </div>
            <!-- 动态属性开始 -->

            <div class="card-item" v-for="(item,index) in trendParamAttr" :key="index">
              <div class="item item-label">{{item.name}}</div>
              <div class="item item-value">{{item.cks}}</div>
            </div>

            <!-- 动态属性结束 -->
            <div class="card-item">
              <div class="item item-label">备注</div>
              <div class="item item-textarea"></div>
            </div>
            <div class="card-item" style="height: auto;padding: 5px 0 0 0.4rem">{{userInfo.remark}}</div>
          </div>
        </div>
      </div>
    </div>
    <page-none v-if="noData =='true'" />
  </div>
</template>
<script type="text/ecmascript-6">
import { getStaffDetails } from "@/common/api";
import { toast } from "@/common/api/api.js";
import topPart from "../../components/topPart";
import pageNone from "../../components/pageNone";
export default {
  name: "persinnelDetail",
  components: {
    topPart,
    pageNone
  },
  data() {
    return {
      userInfo: {},
      paramAttr: [
        {
          key: "staffStatus", //会员状态
          value: "status"
        },
        {
          key: "staffIdentity", //会员身份
          value: "identity"
        }
      ],
      defineParamAttr: [
        //pc可修改的人员字典属性获取
        {
          //职称
          key: "post", //需要传给后端的字串
          value: "post" //需要在页面展示的字段
        },
        {
          key: "jobTitle", //岗位
          value: "jobTitle"
        }
      ],
      trendParamAttr: [],
      personalId: "",
      noData: ""
    };
  },
  created() {
    // this.init();
    // this.personalId = this.$route.query.id&&this.$route.query.id;
    this.getPersonDetails();
    //匹配岗位数据函数
    this.findStation();
  },
  methods: {
    transfromDate(item) {
      var trendFlag = this.userInfo[item.fieldp]; //人员标志位
      return trendFlag;
    },
    // 获取动态属性
    gainTrendParams() {
      this.centralControl.axios.centralControl(
        "getListDate",
        res => {
          if (res.code == 200) {
            this.paramAttrs(res.data);
            //this.trendParamAttr = res.data;
          } else {
            this.$message.error(res.message);
          }
        },
        {}
      );
    },
    // 判断动态属性是否为空
    paramAttrs(data) {
      var arr = [];
      for (let i in data) {
        var str = this.transfromDate(data[i]);
        if (str != "") {
          data[i].cks = str;
          arr.push(data[i]);
        }
      }
      this.trendParamAttr = arr;
    },
    // 初始化数据
    init() {
      // this.eachDate(this.paramAttr);
    },
    //循环配置数组
    eachDate(attr, hrefUrl) {
      for (let val in attr) {
        this.getDictionaryValue(attr[val], hrefUrl);
      }
    },
    // 获取人员字典属性
    getDictionaryValue(type, urlHref) {
      this.centralControl.axios.centralControl(
        urlHref,
        res => {
          if (res.code == 200) {
            this.gainDate(res.data, type);
            console.log(res.data);
          } else {
            // Toast(res.message);
            toast(this, res.message, "error");
          }
        },
        {
          dictType: type.key
        }
      );
    },
    // 根据数据匹配数据
    gainDate(attr, infoName) {
      attr.forEach((a, b) => {
        if (this.userInfo[infoName.value]) {
          if (a.dictValue == this.userInfo[infoName.value]) {
            this.$set(this.userInfo, infoName.value, a.dictLabel);
          }
        }
      });
    },
    // 获取会员信息
    getPersonDetails() {
      getStaffDetails({
        id: this.$route.query.id
      }).then(res => {
        if (res.code == 200) {
          this.noData = "false";
          this.userInfo = res.data;
          this.eachDate(this.paramAttr, "getDictValue");
          this.eachDate(this.defineParamAttr, "getUserDictValue");
          this.gainTrendParams();
          console.log(this.userInfo);
        } else {
          // toast(this, res.message, "error");
          this.noData = "true";
        }
      });
    },
    back() {
      this.$router.go(-1);
    },
    callTel(tel) {
      if (!tel) return;
      let telNode = document.createElement("a");
      telNode.style.display = "none";
      telNode.href = "tel:" + tel;
      telNode.click();
    },
    findStation() {
      let stationDate = this.centralControl.config["station"];
      console.log(stationDate);
    }
  },
  filters: {
    // filterStatus: val => {
    //   if (!val) return;
    //   return val == 0
    //     ? "在职"
    //     : val == 1
    //     ? "离职"
    //     : val == 2
    //     ? "返聘"
    //     : val == 3
    //     ? "退休"
    //     : "";
    // },
    //filterIdentity
    // filterIdentity: val => {
    //   if (!val) return;
    //   return val == 4
    //     ? "工会主席"
    //     : val == 1
    //     ? "分会员工"
    //     : val == 2
    //     ? "工会员工"
    //     : val == 3
    //     ? "分会主席"
    //     : val == 5
    //     ? "系统管理员"
    //     : "";
    // }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../assets/stylus/theme.styl';
@import '../../assets/stylus/common.styl';

.my-content {
  myContent();
}

.sino-personal {
  .sino-panel {
    height: 100vh;
    width: 100vw;
    padding-bottom: 0px;

    .sino-content {
      height: calc(100%);
      overflow: scroll;
    }

    .content-card {
      background: rgba(255, 255, 255, 1);
      font-size: 16px;
      color: rgba(53, 53, 53, 1);

      .card-item {
        height: 50px;
        display: flex;

        .item {
          flex: 1;
          display: flex;
          align-items: center;
        }

        .item-label {
          padding-left: 0.4rem;
        }

        .item-value {
          justify-content: flex-end;
          text-align: right;
          padding-right: 0.4rem;
          opacity: 0.6;

          .cube-input-field {
            text-align: right;
          }
        }
      }
    }
  }
}
</style>